import crownPrincess1 from "./assets/crown-princess-1.jpeg";
import crownPrincess2 from "./assets/crown-princess-2.jpeg";
import veraBear1 from "./assets/vera-bear-1.jpeg";
import veraBear2 from "./assets/vera-bear-2.jpeg";
import romanceBerry1 from "./assets/romance-berry-1.jpeg";
import romanceBerry2 from "./assets/romance-berry-2.jpeg";
import velvetGlow1 from "./assets/velvet-glow-1.jpeg";
import velvetGlow2 from "./assets/velvet-glow-2.jpeg";
import rubyDuby1 from "./assets/ruby-duby-1.jpeg";
import rubyDuby2 from "./assets/ruby-duby-2.jpeg";
import pearl1 from "./assets/pearl-1.jpeg";
import pearl2 from "./assets/pearl-2.jpeg";
import firstLove1 from "./assets/first-love-1.jpeg";
import firstLove2 from "./assets/first-love-2.jpeg";
import adore1 from "./assets/adore-1.jpeg";
import adore2 from "./assets/adore-2.jpeg";
import woaini1 from "./assets/woaini-1.jpeg";
import woaini2 from "./assets/woaini-2.jpeg";
import devoted1 from "./assets/devoted-1.jpeg";
import devoted2 from "./assets/devoted-2.jpeg";
import everlasting1 from "./assets/everlasting-1.jpeg";
import everlasting2 from "./assets/everlasting-2.jpeg";
import minis1 from "./assets/minis-mono-1.jpeg";
import minis2 from "./assets/minis-mono-2.jpeg";
import floral1 from "./assets/floral-mono-1.jpeg";
import floral2 from "./assets/floral-mono-2.jpeg";
import oceans1 from "./assets/oceans-mono-1.jpeg";
import oceans2 from "./assets/oceans-mono-2.jpeg";

export const data = [
    {
        index: 0,
        price_id: "price_1MtAvtGZRtKSKH8eIuY4LcVh",
        cakeName: "Crown Princess",
        slug: "crown-princess",
        category: "vintage",
        images: [crownPrincess1, crownPrincess2],
        details: {
            price: 95,
            description: [
                "Classic, simple, clean but nothing short of elegance and grace.", 
                "Vintage cakes are all handpipped lace by lace, piece by piece made to into a masterpiece.",
                "Cake comes with wooden ' Happy Birthday ' topper, sparkling candle and firework candle.",
            ],
        },

    },
    {
        index: 1,
        price_id: "price_1MtAxGGZRtKSKH8eaG0InzM0",
        cakeName: "Vera Bear",
        slug: "vera-bear",
        category: "vintage",
        images: [veraBear1, veraBear2],
        details: {
            price: 95,
            description: [
                "Classic, simple, clean but nothing short of elegance and grace.", 
                "Vintage cakes are all handpipped lace by lace, piece by piece made to into a masterpiece.",
                "Cake comes with wooden ' Happy Birthday ' topper, sparkling candle and firework candle.",
            ],
        },
    },
    {
        index: 2,
        price_id: "price_1MyYXSGZRtKSKH8eDndNmLVP",
        cakeName: "Romance Berry",
        slug: "romance-berry",
        category: "vintage",
        images: [romanceBerry1, romanceBerry2],
        details: {
            price: 95,
            description: [
                "Classic, simple, clean but nothing short of elegance and grace.", 
                "Vintage cakes are all handpipped lace by lace, piece by piece made to into a masterpiece.",
                "Cake comes with wooden ' Happy Birthday ' topper, sparkling candle and firework candle.",
            ],
        },
    },
    {
        index: 3,
        price_id: "price_1MtAxjGZRtKSKH8e1DNBf30u",
        cakeName: "Velvet Glow",
        slug: "velvet-glow",
        category: "vintage",
        images: [velvetGlow1, velvetGlow2],
        details: {
            price: 95,
            description: [
                "Classic, simple, clean but nothing short of elegance and grace.", 
                "Vintage cakes are all handpipped lace by lace, piece by piece made to into a masterpiece.",
                "Cake comes with wooden ' Happy Birthday ' topper, sparkling candle and firework candle.",
            ],
        },
    },
    {
        index: 4,
        price_id: "price_1MyYYPGZRtKSKH8eMT9iyUIu",
        cakeName: "Ruby Duby",
        slug: "ruby-duby",
        category: "vintage",
        images: [rubyDuby1, rubyDuby2],
        details: {
            price: 95,
            description: [
                "Classic, simple, clean but nothing short of elegance and grace.", 
                "Vintage cakes are all handpipped lace by lace, piece by piece made to into a masterpiece.",
                "Cake comes with wooden ' Happy Birthday ' topper, sparkling candle and firework candle.",
            ],
        },
    },
    {
        index: 5,
        price_id: "price_1MtAykGZRtKSKH8ejIrcwUGz",
        cakeName: "Pearl",
        slug: "pearl",
        category: "wedding",
        images: [pearl1, pearl2],
        details: {
            price: 250,
            description: [
                "Cheers to the lovely couple, let's celebrate love with a breathtaking cake!",
                "These bespoke cakes are suitable for a ROM, Wedding ceremony or even just a fancy party,",
                "Comes with sparkling candle and firework candle",
            ],
        },
    },
    {
        index: 6,
        price_id: "price_1MtAzXGZRtKSKH8exqyGDbnz",
        cakeName: "First Love",
        slug: "first-love",
        category: "wedding",
        images: [firstLove1, firstLove2],
        details: {
            price: 250,
            description: [
                "Cheers to the lovely couple, let's celebrate love with a breathtaking cake!",
                "These bespoke cakes are suitable for a ROM, Wedding ceremony or even just a fancy party,",
                "Comes with sparkling candle and firework candle",
            ],
        },
    },
    {
        index: 7,
        price_id: "price_1MtB0nGZRtKSKH8elITpS3SZ",
        cakeName: "Adore",
        slug: "adore",
        category: "wedding",
        images: [adore1, adore2],
        details: {
            price: 250,
            description: [
                "Cheers to the lovely couple, let's celebrate love with a breathtaking cake!",
                "These bespoke cakes are suitable for a ROM, Wedding ceremony or even just a fancy party,",
                "Comes with sparkling candle and firework candle",
            ],
        },
    },
    {
        index: 8,
        price_id: "price_1MtB17GZRtKSKH8eYxN0xRZz",
        cakeName: "Wo Ai Ni",
        slug: "wo-ai-ni",
        category: "wedding",
        images: [woaini1, woaini2],
        details: {
            price: 250,
            description: [
                "Cheers to the lovely couple, let's celebrate love with a breathtaking cake!",
                "These bespoke cakes are suitable for a ROM, Wedding ceremony or even just a fancy party,",
                "Comes with sparkling candle and firework candle",
            ],
        },
    },
    {
        index: 9,
        price_id: "price_1MtB1KGZRtKSKH8eqBDOAKUB",
        cakeName: "Devoted",
        slug: "devoted",
        category: "wedding",
        images: [devoted1, devoted2],
        details: {
            price: 250,
            description: [
                "Cheers to the lovely couple, let's celebrate love with a breathtaking cake!",
                "These bespoke cakes are suitable for a ROM, Wedding ceremony or even just a fancy party,",
                "Comes with sparkling candle and firework candle",
            ],
        },
    },
    {
        index: 10,
        price_id: "price_1MtB1RGZRtKSKH8ev7LCHgvt",
        cakeName: "Everlasting",
        slug: "everlasting",
        category: "wedding",
        images: [everlasting1, everlasting2],
        details: {
            price: 250,
            description: [
                "Cheers to the lovely couple, let's celebrate love with a breathtaking cake!",
                "These bespoke cakes are suitable for a ROM, Wedding ceremony or even just a fancy party,",
                "Comes with sparkling candle and firework candle",
            ],
        },
    },
    {
        index: 11,
        price_id: "price_1MyYZNGZRtKSKH8ehKXOSWe8",
        cakeName: "Minis Monogram Cookie",
        slug: "minis-monogram-cookie",
        category: "monogram",
        images: [minis1, minis2],
        details: {
            price: 200,
            description: [
                "This monogram cake will be best for a small, but nonetheless special celebration!",
                "Ideal for anyone looking for a monogram cake with 2 mini letters/numbers.",
                "Comes with sparkling candle and firework candle.",
            ],
        },
    },
    {
        index: 12,
        price_id: "price_1MtB2DGZRtKSKH8enG4yGihg",
        cakeName: "Floral Monogram Cookie",
        slug: "floral-monogram-cookie",
        category: "monogram",
        images: [floral1, floral2],
        details: {
            price: 200,
            description: [
                "This monogram cake will be best for a small, but nonetheless special celebration!",
                "Ideal for anyone looking for a monogram cake with 2 mini letters/numbers.",
                "Comes with sparkling candle and firework candle.",
            ],
        },
    },
    {
        index: 13,
        price_id: "price_1MtB2LGZRtKSKH8eOFyPbfOT",
        cakeName: "Ocean Pastels Monogram",
        slug: "ocean-pastels-monogram",
        category: "monogram",
        images: [oceans1, oceans2],
        details: {
            price: 200,
            description: [
                "This monogram cake will be best for a small, but nonetheless special celebration!",
                "Ideal for anyone looking for a monogram cake with 2 mini letters/numbers.",
                "Comes with sparkling candle and firework candle.",
            ],
        },
    },
]

export default data